// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"9354c5a1","131":"3e28d812","278":"66944899","453":"34225dfd","518":"b73dc6eb","712":"9aeceaa4","756":"ada99909","791":"efe09693","885":"a8bc8b06","938":"a117c496"}[chunkId] + ".chunk.js";
};